// extracted by mini-css-extract-plugin
module.exports = {"live_img":"Assets_live_img__2cQei","blink":"Assets_blink__2GVfc"};